import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import AppSpinner from '../app-spinner';
import './styles.scss';
import FooterWave from '../footer/footer-wave';

interface PageLoaderProps {
  stringsDefault: any;
  globalStyles: any
}

const NewPageLoader = ({stringsDefault, globalStyles}: PageLoaderProps) => {

  return (
    <>
      <div className="loading-container">
        <AppSpinner />
        <div className="loading-text">
          <p className="laoding-text-reason">
            {stringsDefault?.pt?.messages?.loading_your_insurance_data}
          </p>
        </div>
      </div>
      <FooterWave
        color={globalStyles && globalStyles?.primaryColor}
        pinToBottom={true}></FooterWave>
    </>
  );
};

const mapStateToProps = ({stringsDefault, globalStyles}: any) => ({
  stringsDefault: stringsDefault.value,
  globalStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(NewPageLoader)
);
